const requiredEnv = [
  'VITE_COGNITO_DOMAIN',
  'VITE_COGNITO_CLIENT_ID',
  'VITE_REDIRECT_URI',
  'VITE_LOGOUT_URI',
  'VITE_API_BASE_URL'
] as const;

type RequiredEnvKey = typeof requiredEnv[number];

type AppConfig = {
  cognitoDomain: string;
  clientId: string;
  redirectUri: string;
  logoutUri: string;
  apiBaseUrl: string;
  defaultUploadFolder: string;
  maxResults: number;
};

function getEnv(key: RequiredEnvKey): string {
  const value = import.meta.env[key];
  if (!value) {
    throw new Error(`Missing required environment variable: ${key}`);
  }
  return value;
}

export const config: AppConfig = {
  cognitoDomain: getEnv('VITE_COGNITO_DOMAIN').replace(/\/$/, ''),
  clientId: getEnv('VITE_COGNITO_CLIENT_ID'),
  redirectUri: getEnv('VITE_REDIRECT_URI'),
  logoutUri: getEnv('VITE_LOGOUT_URI'),
  apiBaseUrl: getEnv('VITE_API_BASE_URL').replace(/\/$/, ''),
  defaultUploadFolder: import.meta.env.VITE_DEFAULT_UPLOAD_FOLDER || '',
  maxResults: Number(import.meta.env.VITE_MAX_RESULTS || 24)
};
